import React, { useCallback, useMemo } from 'react';

import { useStoreConfig } from 'src/components/AppShell/ConfigProvider';

import { getWidgetId } from './get-widget-id';
import { YotpoWidget } from './yotpo-widget';

const baseKey = 'yotpoWidget';

const YOTPO_WIDGETS = {
    ProductReviews: `${baseKey}ProductReviews`,
    ProductStars: `${baseKey}ProductStars`,
} as const;

type YotpoWidgetNames = keyof typeof YOTPO_WIDGETS;

export const useYotpoWidget = () => {
    const { cmsBlocks } = useStoreConfig();

    const createYotpoComponent = useCallback(
        (widgetName: string): YotpoWidget | null => {
            return (widgetProps) => {
                const value = cmsBlocks[YOTPO_WIDGETS[widgetName]];
                const widgetId = getWidgetId(value);

                const productId = widgetProps.product?.id;
                const key = `${widgetId}-${productId}`;

                if (!widgetId || !productId) {
                    return null;
                }

                return <YotpoWidget {...widgetProps} key={key} instanceId={widgetId} />;
            };
        },
        [cmsBlocks],
    );

    const components = useMemo(
        () =>
            Object.keys(YOTPO_WIDGETS).reduce((acc, componentName) => {
                acc[componentName] = createYotpoComponent(componentName);

                return acc;
            }, {} as Record<YotpoWidgetNames, YotpoWidget>),
        [createYotpoComponent],
    );

    return components;
};
